// getAllLocations (CatalogController) groups stores by catalogId
// ({ [catalogId]: { stores: [...] } }); most callers just want a flat store
// list (optionally tagged with the catalogId each store belongs to) for a
// picker/autocomplete.
export function flattenLocationStores(locationsResponse, { withCatalogId = true } = {}) {
    return Object.entries(locationsResponse || {}).flatMap(([catalogId, value]) => {
        const stores = value?.stores || [];
        return withCatalogId ? stores.map((s) => ({ catalogId, ...s })) : stores;
    });
}
